// extracted by mini-css-extract-plugin
module.exports = {"grid":"start-page-lower_grid__20W5c"};